export default __webpack_public_path__ + "static/media/buttonDanceInActive.e27ebe29.svg";